import Model from './Model'

export default class MarketingMessage extends Model {
  resource()
  {
    return 'marketing-messages'
  }
}
